import React from 'react';

const ParagraphElement = ({ element }) => {
  const { content } = element;
  const { text = '', alignment = 'left', fontSize = 'normal' } = content || {};

  const style = {
    textAlign: alignment,
    fontSize: fontSize === 'small' ? '0.875rem' : fontSize === 'large' ? '1.125rem' : '1rem',
    margin: '0.5em 0',
    lineHeight: '1.6',
    color: 'var(--color-text)'
  };

  return <p className="builder-paragraph" style={style}>{text}</p>;
};

export default ParagraphElement;
